import { combineReducers } from '@reduxjs/toolkit';
import changePasswordReducer from './change-password';
import loginReducer from './login';

const systemUserReducer = combineReducers({
  changePassword: changePasswordReducer,
  login: loginReducer
});

export default systemUserReducer;